import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  country: '',
  taskPlanetAppReview: false,
};

const userProfileSlice = createSlice({
  name: "userProfile",
  initialState,
  reducers: {
    setUserProfile: (state, action) => {
      console.log("action.payload.country",action.payload.country)
      state.country = action.payload.country;
      state.taskPlanetAppReview = action.payload.taskPlanetAppReview || false;
    },
  },
});

export const { setUserProfile } = userProfileSlice.actions;
export default userProfileSlice.reducer;
